export const CAMPAIGNS_SELECTOR = {
    PLACEHOLDER: 'Campaigns',
};

export const TEST_IDS = {
    valueCampaignsOption: 'campaign-value-option',
};
